import React, { useMemo } from "react";
import VStack from "../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import type { Meta, StoryObj } from "@storybook/react";
import { createStackNavigator } from "@react-navigation/stack";
import WorkerInvitationDetailsScreen from "../../screens/user/WorkerInvitationDetails";
import { ProfileType } from "../../__generated__/graphql";
import { buildClientProfile, buildInvitation, buildUser } from "../factories";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { ACCEPT_INVITATION, GET_INVITATION, REJECT_INVITATION } from "../../graphql/invitation";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

const Stack = createStackNavigator<{
    WorkerInvitationDetailsScreen: undefined;
}>();

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: GET_INVITATION,
            },
            variableMatcher: () => true,
            newData: () => {
                return {
                    data: {
                        getInvitation: buildInvitation(),
                    },
                };
            },
        },
        {
            request: {
                query: ACCEPT_INVITATION,
            },
            variableMatcher: () => true,
            newData: () => {
                return {
                    data: {},
                };
            },
        },
        {
            request: {
                query: REJECT_INVITATION,
            },
            variableMatcher: () => true,
            newData: () => {
                return {
                    data: {},
                };
            },
        },
    ];
    const user = useMemo(
        () =>
            buildUser({
                clientProfiles: [buildClientProfile()],
            }),
        [],
    );

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Client}>
                <MockedProvider mocks={mocks}>
                    <VStack
                        gap={1}
                        style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}
                    >
                        <Stack.Navigator initialRouteName="WorkerInvitationDetailsScreen">
                            <Stack.Screen
                                name="WorkerInvitationDetailsScreen"
                                // @ts-expect-error - navigation prop is not used in the story
                                component={WorkerInvitationDetailsScreen}
                                options={{ headerShown: true, title: "Invitation" }}
                            />
                        </Stack.Navigator>
                    </VStack>
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/Invitation worker",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
